import { Link } from "react-router-dom";

export const Logo = ({ tone = "dark", to = "/", className = "", testid = "nav-logo" }) => {
  const ink = tone === "light" ? "#FFFCFA" : "#2C2B2C";
  const gold = "#FBC4A8";
  const rays = [0, 30, 60, 90, 120, 150, 180];
  return (
    <Link to={to} data-testid={testid} className={`group flex items-center gap-3 ${className}`}>
      <svg viewBox="0 0 44 44" className="h-9 w-9 flex-none transition-transform duration-500 group-hover:rotate-[8deg]">
        <circle cx="22" cy="22" r="20.5" fill="none" stroke={gold} strokeWidth="1" opacity="0.7" />
        <line x1="11" y1="27" x2="33" y2="27" stroke={ink} strokeWidth="1.3" strokeLinecap="round" />
        <path d="M14 27 a8 8 0 0 1 16 0" fill="none" stroke={ink} strokeWidth="1.3" strokeLinecap="round" />
        {rays.map((a) => {
          const r = (a * Math.PI) / 180;
          const x1 = 22 - Math.cos(r) * 10.5;
          const y1 = 27 - Math.sin(r) * 10.5;
          const x2 = 22 - Math.cos(r) * 13;
          const y2 = 27 - Math.sin(r) * 13;
          return <line key={a} x1={x1} y1={y1} x2={x2} y2={y2} stroke={gold} strokeWidth="1.1" strokeLinecap="round" />;
        })}
      </svg>
      <span className="leading-none">
        <span className="font-display text-[1.35rem] tracking-[0.14em]" style={{ color: ink }}>AURA GLOW</span>
      </span>
    </Link>
  );
};
